import { Building, Education, Home } from '@carbon/icons-react';

export const FACILITY_TYPE_ICONS = {
  'Family Child Care Home': Home,
  'Child Care Center': Building,
  School: Education,
  'In-Home Provider': Home,
};
